import { OneOrManySchema } from 'notable-common';
import { z } from 'zod';
import { FlowDurationUnits } from '../../../duration/duration.js';
import { FlowDurationSchemaWithMax } from '../../../duration/withMax.js';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
import { FlowFhirResourceType, FlowHieDocumentFormat } from './enums.js';
export const BaseFlowHieGetDocumentsBlockConfigSchema = z.object({
    sourceBlock: z.object({
        sourceBlockName: z.string(),
    }),
    timeout: FlowDurationSchemaWithMax({
        pathName: 'timeout',
        max: { value: 30, units: FlowDurationUnits.Minutes },
    }),
});
export const BaseFlowHieConsolidatedBlockConfigSchema = BaseFlowHieGetDocumentsBlockConfigSchema.extend({
    resources: OneOrManySchema(z.enum(FlowFhirResourceType)).default([]),
    dateTo: z.string().optional(),
    dateFrom: z.string().optional(),
});
export const FlowHieConsolidatedJsonConfigSchema = BaseFlowHieConsolidatedBlockConfigSchema.extend({
    documentFormat: z.enum([FlowHieDocumentFormat.ConsolidatedData]),
    includeRelatedRecords: z.boolean().default(false),
});
export const FlowHieConsolidatedRenderedConfigSchema = BaseFlowHieConsolidatedBlockConfigSchema.extend({
    documentFormat: z.enum([
        FlowHieDocumentFormat.ConsolidatedDataPdf,
        FlowHieDocumentFormat.ConsolidatedDataHtml,
    ]),
});
export const FlowHieBulkDownloadUrlsConfigSchema = BaseFlowHieGetDocumentsBlockConfigSchema.extend({
    documentFormat: z.literal(FlowHieDocumentFormat.BulkDownloadUrls),
});
export const FlowHieGetDocumentsBlockConfigSchema = z.discriminatedUnion('documentFormat', [
    FlowHieConsolidatedJsonConfigSchema,
    FlowHieConsolidatedRenderedConfigSchema,
    FlowHieBulkDownloadUrlsConfigSchema,
]);
export const FlowHieGetDocumentsBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.HieGetDocuments),
    config: FlowHieGetDocumentsBlockConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.Any),
});
//# sourceMappingURL=config.js.map